var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8,11L7,9.2C6.9,9.1,6.7,9,6.5,9C6.2,9,6,9.1,5.9,9.2C5.7,9.4,5.6,9.6,5.6,9.8c0,0.2,0.1,0.4,0.2,0.6l2.4,2.4 C8.4,13,8.6,13,8.8,13c0.2,0,0.4-0.1,0.6-0.2l4.7-4.7c0.2-0.2,0.2-0.3,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.3-0.2-0.6-0.2 c-0.2,0-0.4,0.1-0.6,0.2L8.8,11z M4.2,15.8h11.7V4.2H4.2V15.8z M4.2,17.5c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.2V4.2 C2.5,3.7,2.7,3.3,3,3c0.3-0.3,0.7-0.5,1.2-0.5h3.5C7.8,2,8.1,1.6,8.6,1.3C9,1,9.5,0.8,10,0.8c0.5,0,1,0.2,1.4,0.5 c0.4,0.3,0.7,0.7,0.9,1.2h3.5c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.2v11.7c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5 H4.2z M10,3.5c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.4-0.2 c-0.2,0-0.3,0.1-0.4,0.2C9.4,2.6,9.4,2.7,9.4,2.9c0,0.2,0.1,0.3,0.2,0.4C9.7,3.5,9.8,3.5,10,3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/Attendance.b85311d5f0c4ab522dec0cc5e9407823.svg";
export { ForwardRef as ReactComponent };